import { render, staticRenderFns } from "./Assistant.vue?vue&type=template&id=f31b87d8&scoped=true&"
import script from "./Assistant.vue?vue&type=script&lang=ts&"
export * from "./Assistant.vue?vue&type=script&lang=ts&"
import style0 from "./Assistant.vue?vue&type=style&index=0&id=f31b87d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31b87d8",
  null
  
)

export default component.exports